import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import {
  Modal,
  Button
} from '../NarusMaterial'

import { CLEAR_DOCUMENT } from './actions'
import Document from './document'

class DocumentModal extends React.Component {
  UNSAFE_componentWillMount () {
    const { dispatch } = this.props
    dispatch({ type: CLEAR_DOCUMENT })
  }

  renderDocument () {
    const { meta } = this.props

    const { mime_type: mime, id, filename, data } = meta

    return (
      <Document
        mime={mime}
        id={id}
        fileName={filename}
        data={data?.startsWith('data:') ? data.split(',')[1] : data}
      />
    )
  }

  render () {
    const { close, open } = this.props
    const actions = [
      <Button
        label='Close'
        key='a'
        onClick={close}
      />
    ]

    if (open) {
      return (
        <Modal actions={actions}>
          {this.renderDocument()}
        </Modal>
      )
    }

    return null
  }
}

DocumentModal.propTypes = {
  meta: PropTypes.instanceOf(Object).isRequired,
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
}

export default connect()(DocumentModal)
